import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-506c96ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["title"]
const _hoisted_2 = { class: "title" }
const _hoisted_3 = {
  key: 0,
  style: {"text-align":"center"}
}

import { computed } from 'vue';

export default /*#__PURE__*/_defineComponent({
  ...{
  inheritAttrs: false,
},
  __name: 'Popup',
  props: {
    modelValue: { type: Boolean },
    title: {},
    contents: {},
    hasClose: { type: Boolean },
    disableDefaultToolTip: { type: Boolean }
  },
  emits: ["update:modelValue", "close"],
  setup(__props: any, { emit: __emit }) {


const props = __props;
const emits = __emit;
const showing = computed({
    get(){
        return props.modelValue;
    },
    set(val:boolean){
        emits('update:modelValue',val);
    }
});
function ClosePopup() {
    showing.value = false;
    emits('close');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "#app" }, [
    (showing.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          onClick: ClosePopup,
          title: _ctx.disableDefaultToolTip ? '' : 'Click outside of popup to close it.',
          class: "overlay"
        }, [
          _createElementVNode("div", _mergeProps({
            onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
            class: "popup"
          }, _ctx.$attrs), [
            _renderSlot(_ctx.$slots, "default", {}, () => [
              _createElementVNode("div", _hoisted_2, [
                _renderSlot(_ctx.$slots, "title", {}, () => [
                  _createTextVNode(_toDisplayString(_ctx.title), 1)
                ])
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["popup-contents", { contents:!!_ctx.$slots['contents'] }])
              }, [
                _renderSlot(_ctx.$slots, "contents", {}, () => [
                  _createTextVNode(_toDisplayString(_ctx.contents), 1)
                ])
              ], 2)
            ])
          ], 16),
          (_ctx.hasClose)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("button", {
                  class: "popup-button",
                  onClick: ClosePopup,
                  title: "Close popup."
                }, " Close ")
              ]))
            : _createCommentVNode("", true)
        ], 8, _hoisted_1))
      : _createCommentVNode("", true)
  ]))
}
}

})